export const businessTypeList = [
  { name: '全部', id: null },
  { name: '易资源', id: 1 },
  { name: '询比价', id: 2 }
];
export const divideProfitTypeList = [
  { name: '全部', id: null },
  { name: '客户引入方', id: 1 },
  { name: '资源引入方', id: 2 }
];

export const divideProfitStatusList = [
  { name: '全部', id: null },
  { name: '未分配', id: 0 },
  { name: '已分配', id: 1 }
];

export function getDictName(list, value) {
  return list.find(item => value === item.id)?.name;
}